import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import customO from '../components/rounded_beanbonus_icon_512.png';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig'; // Website's functions instance

function HeaderBlock() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [firstName, setFirstName] = useState('');

  // New states for scroll behavior
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Functions instance
  const signInUser = httpsCallable(functions, 'signInUser');

  // Toggle dropdown and close on link click
  const toggleMenu = (e, close = false) => {
    if (close && isMenuOpen) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  // Toggle modal
  const toggleModal = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsModalOpen(!isModalOpen);
    setError(null);
    setEmail('');
    setPassword('');
  };

  // Handle sign-in
  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const result = await signInUser({ email, password });
      const { uid, firstName } = result.data;
      console.log('Received UID and firstName:', uid, firstName);

      // Update UI with returned data
      setUser({ uid });
      setFirstName(firstName);
      setError(null);
      toggleModal();
    } catch (err) {
      console.error('Sign-in error:', err.message);
      setError(err.message || 'Failed to sign in. Please try again.');
    }
  };

  // Handle sign-out
  const handleSignOut = async () => {
    setUser(null);
    setFirstName('');
    setError(null);
    setIsMenuOpen(false);
  };

  // Scroll listener effect
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down past threshold: hide
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up: show (slow drop down)
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    // Throttle scroll event for performance (every 150ms)
    let timeout;
    const throttledScroll = () => {
      if (!timeout) {
        timeout = setTimeout(() => {
          handleScroll();
          timeout = null;
        }, 150);
      }
    };

    window.addEventListener('scroll', throttledScroll);
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [lastScrollY]);

  const headerBlockStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    padding: '12px 24px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    width: '100%',
    boxSizing: 'border-box',
    margin: 0, // Removed negative margin to avoid layout shifts
    position: 'fixed', // Changed to fixed for better control
    top: 0,
    left: 0,
    zIndex: 1000,
    transform: isVisible ? 'translateY(0)' : 'translateY(-100%)', // Slide up/down
    transition: 'transform 0.4s ease-in-out', // Smooth animation (adjust duration as needed)
  };

  const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
  };

  const headerLogoStyle = {
    height: '50px',
    width: 'auto',
    marginBottom: '-3px',
  };

  const headerTitleStyle = {
    fontSize: '24px',
    fontWeight: 900,
    color: '#6C441A',
    fontFamily: 'Inter, sans-serif',
  };

  const headerSubtitleStyle = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#A68368',
    fontFamily: 'Inter, sans-serif',
    alignSelf: 'center',
  };

  const headerRightStyle = {
    position: 'relative',
  };

  const headerMenuButtonStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '24px',
    width: '30px',
    padding: 0,
  };

  const hamburgerIconStyle = {
    width: '100%',
    height: '3px',
    backgroundColor: '#A68368',
    borderRadius: '2px',
    transition: 'all 0.3s ease',
  };

  const dropdownMenuStyle = {
    position: 'absolute',
    top: '100%',
    right: 0,
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(240, 240, 240, 0.95))',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: '12px',
    overflow: 'hidden',
    zIndex: 5,
    minWidth: '180px',
    marginTop: '12px',
    padding: '8px 0',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  };

  const dropdownGreetingStyle = {
    padding: '12px 16px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 600,
    color: '#A68368',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  };

  const dropdownItemStyle = {
    display: 'block',
    padding: '12px 16px',
    color: '#A68368',
    borderRadius: '12px',
    textDecoration: 'none',
    fontFamily: 'Inter, sans-serif',
    fontSize: '24px',
    transition: 'background-color 0.3s ease, color 0.3s ease',
    zIndex: 5,
  };

  const signInButtonStyle = {
    width: '100%',
    textAlign: 'center',
    background: 'none',
    border: 'none',
    padding: '12px 16px',
    color: '#f48e28',
    borderRadius: '12px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '24px',
    fontWeight: 900,
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, color 0.3s ease',
  };

  const signInModalStyle = {
    position: 'fixed',
    top: '200px',
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  };

  const modalContentStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    padding: '24px',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '80%',
    position: 'relative',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  };

  const modalCloseStyle = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#A68368',
    cursor: 'pointer',
  };

  const modalSignInButtonStyle = {
    width: '40%',
    padding: '12px',
    backgroundColor: '#f48e28',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  return (
    <div style={headerBlockStyle}>
      <div style={headerLeftStyle}>
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
          <div>
            <img src={customO} alt="BeanBonus Logo" style={headerLogoStyle} />
          </div>
          <div style={{ flexDirection: 'row', marginLeft: '8px' }}>
            <div style={headerTitleStyle}>BeanBonus</div>
            <div style={headerSubtitleStyle}>The Coffee App</div>
          </div>
        </Link>
      </div>
      <div style={headerRightStyle}>
        <button
          style={headerMenuButtonStyle}
          aria-label="Menu"
          onClick={toggleMenu}
        >
          <span style={hamburgerIconStyle}></span>
          <span style={hamburgerIconStyle}></span>
          <span style={hamburgerIconStyle}></span>
        </button>
        {isMenuOpen && (
          <div style={dropdownMenuStyle}>
            <>
              <Link to="/" style={dropdownItemStyle} onClick={(e) => toggleMenu(e, true)}>Home</Link>
              <Link to="/about-us" style={dropdownItemStyle} onClick={(e) => toggleMenu(e, true)}>About Us</Link>
              <Link to="/blog" style={dropdownItemStyle} onClick={(e) => toggleMenu(e, true)}>Blog</Link>
              <Link to="/events" style={dropdownItemStyle} onClick={(e) => toggleMenu(e, true)}>Events</Link>
            </>
          </div>
        )}
      </div>
      {isModalOpen && (
        <div style={signInModalStyle}>
          <div style={modalContentStyle}>
            <button style={modalCloseStyle} onClick={toggleModal}>×</button>
            <h2 style={{
              margin: '0 0 16px',
              fontFamily: 'Inter, sans-serif',
              fontSize: '24px',
              color: '#A68368',
              textAlign: 'center',
            }}>Sign In</h2>
            <form onSubmit={handleSignIn}>
              <input
                style={{ width: '90%', padding: '12px', marginBottom: '12px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '8px', fontFamily: 'Inter, sans-serif', fontSize: '16px', color: '#333' }}
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                style={{ width: '90%', padding: '12px', marginBottom: '12px', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: '8px', fontFamily: 'Inter, sans-serif', fontSize: '16px', color: '#333' }}
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {error && <p style={{ color: '#d32f2f', fontFamily: 'Inter, sans-serif', fontSize: '14px', marginBottom: '12px', textAlign: 'center' }}>{error}</p>}
              <button type="submit" style={modalSignInButtonStyle}>Sign In</button>
            </form>
          </div>
        </div>
      )}
      <style jsx>{`
        .header-menu-button:hover .hamburger-icon {
          background-color: #f48e28;
        }
        .header-menu-button.open .hamburger-icon:nth-child(1) {
          transform: translateY(10px) rotate(45deg);
        }
        .header-menu-button.open .hamburger-icon:nth-child(2) {
          opacity: 0;
        }
        .header-menu-button.open .hamburger-icon:nth-child(3) {
          transform: translateY(-10px) rotate(-45deg);
        }
        .dropdown-item:hover {
          background-color: #f48e28;
          color: #fff;
        }
        .sign-in-button:hover, .sign-out-button:hover {
          background-color: #f48e28;
          color: #fff;
        }
        .modal-content input:focus {
          outline: none;
          border-color: #f48e28;
        }
        .modal-sign-in-button:hover {
          background-color: #cc7722;
        }
      `}</style>
    </div>
  );
}

export default HeaderBlock;